import {
  WS_APRIL,
  WS_AUGUST,
  WS_DECEMBER,
  WS_FEBRUARY,
  WS_JANUARY,
  WS_JULY,
  WS_JUNE,
  WS_MARCH,
  WS_MAY,
  WS_NOVEMBER,
  WS_OCTOBER,
  WS_SEPTEMBER,
} from '@pages/WorkSchedule/constants/filters';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const months: NWorkSchedule.Month[] = [
  {
    monthId: 0,
    humanMonthId: WS_JANUARY,
    monthTitle: 'ЯНВАРЬ',
    daysInMonth: 31,
  },
  {
    monthId: 1,
    humanMonthId: WS_FEBRUARY,
    monthTitle: 'ФЕВРАЛЬ',
    daysInMonth: 28,
  },
  {
    monthId: 2,
    humanMonthId: WS_MARCH,
    monthTitle: 'МАРТ',
    daysInMonth: 31,
  },
  {
    monthId: 3,
    humanMonthId: WS_APRIL,
    monthTitle: 'АПРЕЛЬ',
    daysInMonth: 30,
  },
  {
    monthId: 4,
    humanMonthId: WS_MAY,
    monthTitle: 'МАЙ',
    daysInMonth: 31,
  },
  {
    monthId: 5,
    humanMonthId: WS_JUNE,
    monthTitle: 'ИЮНЬ',
    daysInMonth: 30,
  },
  {
    monthId: 6,
    humanMonthId: WS_JULY,
    monthTitle: 'ИЮЛЬ',
    daysInMonth: 31,
  },
  {
    monthId: 7,
    humanMonthId: WS_AUGUST,
    monthTitle: 'АВГУСТ',
    daysInMonth: 31,
  },
  {
    monthId: 8,
    humanMonthId: WS_SEPTEMBER,
    monthTitle: 'СЕНТЯБРЬ',
    daysInMonth: 30,
  },
  {
    monthId: 9,
    humanMonthId: WS_OCTOBER,
    monthTitle: 'ОКТЯБРЬ',
    daysInMonth: 31,
  },
  {
    monthId: 10,
    humanMonthId: WS_NOVEMBER,
    monthTitle: 'НОЯБРЬ',
    daysInMonth: 30,
  },
  {
    monthId: 11,
    humanMonthId: WS_DECEMBER,
    monthTitle: 'ДЕКАБРЬ',
    daysInMonth: 31,
  },
];
